import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { ReactElement } from 'react';
import CarouselDesktop from './Desktop';
import CarouselMobile from './Mobile';
import SkeletonList from 'components/Shared/SkeletonList';

interface IProps {
  id?: string;
  title?: string | ReactElement;
  children: ReactElement[];
  isEmpty?: boolean;
  loadingShelf?: boolean;
  fetchingContent?: boolean;
  hasMoreContentToFetch?: boolean;
  fetchMore?: () => void;
}

const useStyles = makeStyles((theme) => ({
  carouselContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    padding: '0px !important',
    paddingBottom: theme.spacing(6),
    '& > div::-webkit-scrollbar': {
      height: 4,
      background: theme.palette.grey[500],
    },
    '& > div::-webkit-scrollbar-thumb': {
      background: theme.palette.grey[700],
    },
  },
  skeleton: {
    marginLeft: theme.spacing(8),
  },
  carouselTitle: {
    color: theme.palette.common.white,
    fontWeight: 700,
    margin: theme.spacing(8, 0, 4, 8),
    '@media(max-width: 1024px)': {
      fontSize: 20,
    },
  },
}));

const Carousel = (props: IProps) => {
  const classes = useStyles();
  const isScreenLarge = useMediaQuery('(min-width: 1025px)');

  if (!props.loadingShelf && props.isEmpty) {
    return null;
  }

  return (
    <div id={props.id ?? 'showcase-shelf'} className={classes.carouselContainer}>
      <Typography id='showcase-title' variant='h3' className={classes.carouselTitle} component='div'>
        {props.title}
      </Typography>

      {props.loadingShelf && (
        <div className={classes.skeleton}>
          <SkeletonList />
        </div>
      )}
      {!props.loadingShelf && (
        <>
          {!isScreenLarge && (
            <CarouselMobile
              fetchMore={props?.fetchMore}
              fetching={props?.fetchingContent}
              hasMoreToFetch={props?.hasMoreContentToFetch}
            >
              {props.children}
            </CarouselMobile>
          )}

          {isScreenLarge && (
            <CarouselDesktop
              hasMoreToFetch={props?.hasMoreContentToFetch}
              fetchMore={props?.fetchMore}
              fetching={props?.fetchingContent}
            >
              {props.children}
            </CarouselDesktop>
          )}
        </>
      )}
    </div>
  );
};

export default Carousel;
